import React from "react";
import { useEffect, useState } from "react";
import {
  CompanyManageGetAutoStock,
  CompanyManageMyStore,
  ProductFilterBerand,
  SiteGetMyStoreSite,
  SiteGetProductSite,
  SiteSetPrices,
  SiteSetStocks,
} from "../../Api/Services";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import imgPlus from "../../assets/Icon/execution.png";
import InputCus from "../../Component/InputCus/Text/InputCus";
import { useNavigate } from "react-router-dom";

function ManegeSite() {
  const [isLoading, setLoading] = useState(true);
  const [CompanyStore, setCompanyStore] = useState([]);
  const [Product, setProduct] = useState([]);
  const [ActiveStore, setActiveStore] = useState();
  const [brands, setBrands] = useState([]);
  const [activeItem, setActiveItem] = useState(null);
  const [Percentage, setPercentage] = useState([]);
  const [Errors, setErrors] = useState([]);
  const navigate = useNavigate();

  const start = async () => {
    try {
      let ErrorList = [];
      const CompanyManageMyStoreData = await CompanyManageMyStore();
      if (
        CompanyManageMyStoreData.status &&
        CompanyManageMyStoreData.status === 200
      ) {
        for (const item of CompanyManageMyStoreData.data.data) {
          const CompanyManageGetAutoStockData = await CompanyManageGetAutoStock(
            item.companyStoreId,
          );
          if (
            CompanyManageGetAutoStockData.status &&
            CompanyManageGetAutoStockData.status === 200
          ) {
            ErrorList.push(...CompanyManageGetAutoStockData.data.data);
            if (CompanyManageGetAutoStockData.data.isSuccess) {
              toast.success(
                ` ارتباط با انبار برای موجودی برقرار شد
                    ${item.companyStoreCompanyName} ${item.companyStoreName}`,
              );
            }
          }
        }
        setErrors(ErrorList);
      }

      const SiteGetMyStoreSiteData = await SiteGetMyStoreSite();
      if (
        SiteGetMyStoreSiteData.status &&
        SiteGetMyStoreSiteData.status === 200
      ) {
        setCompanyStore(SiteGetMyStoreSiteData.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const DoChange = async (id, stock) => {
    let copy = [...Product];
    copy.find((e) => e.id == id).stock = stock;
    setProduct(copy);
  };

  const handleClick = (key) => {
    setActiveItem(activeItem === key ? null : key);
  };

  const confirmSynicPrice = () => {
    confirmAlert({
      title: "بروز رسانی قیمت",
      message: "آیا مطمئن هستید ؟",
      buttons: [
        {
          label: "بله",
          onClick: () => ManegePrice(),
        },
        {
          label: "خیر",
        },
      ],
    });
  };

  const ManegePrice = async () => {
    setLoading(true);
    try {
      const SiteSetPricesData = await SiteSetPrices(ActiveStore);
      if (SiteSetPricesData.status && SiteSetPricesData.status === 200) {
        toast.success("بروزرسانی قیمت با موفقیت انجام شد");
        await start();
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const HandelPercentage = () => {
    const updatedProducts = Product.map((item) => {
      const hasData =
        item.companyProducts.length > 0 &&
        item.companyStorePrices.length > 0 &&
        item.companyStoreStocks.length > 0;

      if (!hasData) return item;

      const originalStock = item.companyStoreStocks[0].stock;

      if (originalStock === 0 || Percentage == 0) {
        return {
          ...item,
          stock: 0,
        };
      }

      const stockValue = Math.round((originalStock * Percentage) / 100);

      return {
        ...item,
        stock: stockValue === 0 ? (Percentage === 0 ? 0 : 1) : stockValue,
      };
    });

    setProduct(updatedProducts);
  };

  const confirmSynicStock = () => {
    confirmAlert({
      title: "بروز رسانی موجودی",
      message: "آیا مطمئن هستید ؟",
      buttons: [
        {
          label: "بله",
          onClick: () => ManegeStock(),
        },
        {
          label: "خیر",
        },
      ],
    });
  };

  const ManegeStock = async () => {
    setLoading(true);
    try {
      let res = [...Product]
        .filter(
          (w) =>
            w.companyProducts.length > 0 &&
            w.companyStorePrices.length > 0 &&
            w.companyStoreStocks.length > 0 &&
            w.stock > 0,
        )
        .map((element) => {
          return {
            Id: element.companyProducts[0]?.code,
            Value: element.stock,
          };
        });
      let model = {
        StoreId: ActiveStore,
        SetStocksDTO: res,
      };
      const SiteSetStocksData = await SiteSetStocks(model);
      if (SiteSetStocksData.status && SiteSetStocksData.status === 200) {
        toast.success("بروزرسانی موجودی با موفقیت انجام شد");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error during login:", error);
    } finally {
      start();
    }
  };

  const SetStore = async (id) => {
    setLoading(true);
    try {
      const ProductFilterBerandData = await ProductFilterBerand({});
      if (
        ProductFilterBerandData.status &&
        ProductFilterBerandData.status === 200
      ) {
        setBrands(ProductFilterBerandData.data.data.data);
        const SiteGetProductSiteData = await SiteGetProductSite(id);
        if (
          SiteGetProductSiteData.status &&
          SiteGetProductSiteData.status === 200
        ) {
          if (SiteGetProductSiteData.data?.message) {
            if (SiteGetProductSiteData.data?.message?.includes("401")) {
              toast.error("نیاز به احراز حویت میباشد");
              navigate("/Panel/Site/Token/" + id);
            } else {
              setProduct(SiteGetProductSiteData.data.data);
            }
          } else {
            setProduct(SiteGetProductSiteData.data.data);
          }
        }
      }
      setActiveStore(id);
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
          <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
            <div className="d-flex justify-content-between align-items-center">
              {CompanyStore &&
                CompanyStore.map((item, key) => (
                  <div
                    className="border border-3 border-black m-2 p-3 rounded pointer"
                    onClick={() => {
                      SetStore(item.companyStoreId);
                    }}
                  >
                    {ActiveStore == item.companyStoreId && (
                      <img
                        height={40}
                        src={imgPlus}
                        alt=""
                        className="bg-warning rounded m-1"
                      />
                    )}
                    <span className="m-2 border border-2 border-black rounded-5 h6 ps-3 pe-3 pt-1 pb-2">
                      {item.companyStoreCompanyName +
                        " ( " +
                        item.companyStoreName +
                        " ) "}
                    </span>
                  </div>
                ))}
            </div>
          </div>
          {ActiveStore && (
            <>
              <div className="d-flex justify-content-center align-item-center flex-column">
                {Errors.map((item) => (
                  <p>{item}</p>
                ))}
              </div>
              <div className="d-flex justify-content-between w-100">
                <div className="d-flex justify-content-center align-items-center">
                  <button onClick={confirmSynicPrice} className="butAU">
                    بروزرسانی قیمت
                  </button>
                </div>
                <div className="d-flex justify-content-center align-items-end flex-column ">
                  <h5>
                    {" "}
                    {Product.reduce((sum, product) => {
                      const stock = product.companyStoreStocks?.[0]?.stock || 0;
                      return sum + stock;
                    }, 0)}{" "}
                    : مجموع انبار{" "}
                  </h5>
                  <h5>
                    {" "}
                    {Product.reduce(
                      (sum, product) => sum + product.stockSite,
                      0,
                    )}{" "}
                    : مجموع سایت{" "}
                  </h5>
                </div>
                <div className="d-flex justify-content-between align-items-center flex-column border border-2 border-black rounded p-2">
                  <div className="d-flex">
                    <InputCus
                      type="text"
                      name="username"
                      id="username"
                      text="درصد موجودی "
                      className="m-2"
                      value={Percentage}
                      onChange={(e) => {
                        setPercentage(e.target.value);
                      }}
                    />
                    <button onClick={HandelPercentage} className="butAU m-2">
                      اعمال درصد
                    </button>
                  </div>

                  <button onClick={confirmSynicStock} className="butAU">
                    بروزرسانی موجودی
                  </button>
                </div>
              </div>

              {brands.map(
                (b, key) =>
                  Product.filter((e) => e.productBerandId == b.id).length >
                    0 && (
                    <>
                      <div
                        key={b}
                        className="d-flex justify-content-around align-items-center w-100 p-3 mt-4 pointer bg-body-secondary border border-1 border-black"
                        onClick={() => handleClick(b.id)}
                      >
                        <h5>{b.name}</h5>
                      </div>
                      {activeItem === b.id && (
                        <div className="d-flex justify-content-center align-items-center w-100 tableC">
                          <table
                            className="table"
                            style={{ lineHeight: "normal" }}
                          >
                            <thead className="sticky-header">
                              <tr className="trTable">
                                <th>سیمبل کالای</th>
                                <th>رنگ</th>
                                <th>کد کالا در شرکت</th>
                                <th>موجودی انبار</th>
                                <th>موجودی فعلی سایت</th>
                                <th>قیمت سایت</th>
                                <th>قیمت</th>
                                <th>موجودی </th>
                              </tr>
                            </thead>
                            <tbody className="identitystyle">
                              {Product &&
                                Product.filter(
                                  (e) => e.productBerandId == b.id,
                                ).map((itemPro, keyPro) => (
                                  <tr
                                    key={keyPro}
                                    className={`
                                      ${
                                        itemPro.companyProducts.length === 0 &&
                                        "bg-warning"
                                      }
                                      ${
                                        itemPro.companyStorePrices.length ===
                                          0 && "bg-secondary"
                                      }
                                      ${
                                        itemPro.companyStoreStocks.length ===
                                          0 && "bg-danger"
                                      }
                                      `}
                                  >
                                    <td>
                                      {itemPro.productTypeName != " " &&
                                        itemPro.productTypeName + " "}
                                      {itemPro.productSeriesName != " " &&
                                        itemPro.productSeriesName}
                                      {itemPro.symbol}
                                      {itemPro.productSeriesEndName != " "
                                        ? itemPro.productSeriesEndName + " "
                                        : " "}
                                      {itemPro.productRamName != " " &&
                                        itemPro.productRamName + "/"}
                                      {itemPro.productRomName != " " &&
                                        itemPro.productRomName + " "}
                                      {itemPro.productNetworkName != " " &&
                                        itemPro.productNetworkName + " "}
                                      {itemPro.productCountryName != " " &&
                                        itemPro.productCountryName + " "}
                                      {itemPro.isInsurance && "بیمه"}
                                    </td>
                                    <td> {itemPro.productColorName} </td>
                                    <td>{itemPro.companyProducts[0]?.code}</td>
                                    <td>
                                      {itemPro.companyStoreStocks[0]?.stock}
                                    </td>
                                    <td>{itemPro.stockSite}</td>
                                    <td>
                                      {itemPro.priceSite
                                        ?.toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </td>
                                    <td>
                                      {(
                                        (itemPro.companyStorePrices[0]?.price ??
                                          "") * 1000
                                      )
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </td>
                                    <td>
                                      <input
                                        id={itemPro.id}
                                        disabled={
                                          itemPro.companyProducts.length ===
                                            0 ||
                                          itemPro.companyStorePrices.length ===
                                            0 ||
                                          itemPro.companyStoreStocks.length ===
                                            0
                                        }
                                        onChange={(e) => {
                                          DoChange(itemPro.id, e.target.value);
                                        }}
                                        value={
                                          Product.find(
                                            (e) => e.id === itemPro.id,
                                          )?.stock
                                        }
                                      />
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </>
                  ),
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ManegeSite;
